import React from 'react';
import Card from '@mui/material/Card';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Section from '../../../elements/Section';
import Title from '../../../elements/Title';
import Content from '../../../elements/Content';
import { classes, BOARD_OF_DIRECTORS } from '../utils';

export default function BoardOfDirectors() {
  return (
    <Section>
      <Title>Board of Directors</Title>
      <Content>
        The Board of Directors is vested with the power to perform all acts that
        are necessary or useful for the realization of the Company’s purpose,
        except for those actions that are specifically reserved by law or the
        Articles of Association for the Shareholders’ Meeting or other
        management bodies.
      </Content>
      <Content>The Board of Directors is composed as follows:</Content>
      <Card variant="outlined" className={classes.card}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Mandate</TableCell>
              <TableCell>Termination Mandate</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {BOARD_OF_DIRECTORS.map((director) => (
              <TableRow hover key={director.name}>
                <TableCell>{director.name}</TableCell>
                <TableCell>{director.mandate}</TableCell>
                <TableCell>
                  After the annual general meeting of account year 2024
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </Section>
  );
}
